"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _AlignTargetProvider = require("redhotmagma-visualization/AlignTargetProvider");
var _i18n = require("../../../../../Framework/i18n");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _Thumbnail = _interopRequireDefault(require("../../Containers/Thumbnail"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    fullscreenPortal: {
      background: 'white',
      position: 'absolute',
      height: '100%',
      width: '100%',
      zIndex: 2,
      top: 0,
      left: 0,
      '& .previewClose': {
        color: 'grey',
        position: 'absolute',
        right: 15,
        top: 15,
        '&:hover': {
          cursor: 'pointer'
        }
      }
    },
    fullScreenTitle: _defineProperty({
      zIndex: 3,
      position: 'absolute',
      width: '100%'
    }, theme.breakpoints.down('xs'), {
      borderTop: '7px solid ' + theme.palette.primary.main
    }),
    visualizationWrapperThumbs: _defineProperty({
      height: 'calc(100% - 200px)'
    }, theme.breakpoints.down('xs'), {
      '& > div:first-child': {
        height: '85% !important'
      },
      height: 'calc(100% - 130px)'
    }),
    visualizationWrapperCanvas: _defineProperty({
      height: '100% '
    }, theme.breakpoints.up('sm'), {
      height: 'calc(100% - 100px)'
    }),
    closePreview: {
      color: theme.palette.primary.darkText,
      fontSize: 15,
      fontWeight: 500,
      lineHeight: '18px',
      textTransform: 'none',
      borderRadius: '4px',
      marginTop: 10,
      '& b': {
        marginLeft: 8
      }
    },
    ClosePreviewRoot: _defineProperty({
      marginBottom: 35
    }, theme.breakpoints.down('xs'), {
      marginBottom: 16
    }),
    closPreviewIconRoot: {
      height: 24,
      width: 24,
      fontSize: '24px',
      lineHeight: '24px',
      textAlign: 'center',
      marginRight: 8
    },
    previewTitle: {
      fontSize: 24,
      fontWeight: 'bold',
      marginLeft: 32,
      paddingTop: 16
    }
  };
};
var PreviewPortal = /*#__PURE__*/function (_React$Component) {
  _inherits(PreviewPortal, _React$Component);
  var _super = _createSuper(PreviewPortal);
  function PreviewPortal() {
    var _this;
    _classCallCheck(this, PreviewPortal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "wrapperRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_assertThisInitialized(_this), "onThumbnailClick", function () {
      return function (thumbnails, src, active) {
        if ((0, _isFunction["default"])(_this.props.thumbnailClick)) {
          _this.props.thumbnailClick(thumbnails, src, active);
        }
      };
    });
    return _this;
  }
  _createClass(PreviewPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.alignTarget.add(this.wrapperRef.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.alignTarget.remove(this.wrapperRef.current);
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var _this$props = this.props,
        hasMoreItems = _this$props.hasMoreItems,
        closePreviewMode = _this$props.closePreviewMode,
        classes = _this$props.classes,
        children = _this$props.children,
        width = _this$props.width,
        dialogStyle = _this$props.dialogStyle;
      var portalStyle = dialogStyle ? classes.fullscreenPortal + ' ' + dialogStyle : classes.fullscreenPortal;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: portalStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.fullScreenTitle
      }, width === 'xs' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        component: "div",
        className: classes.previewTitle
      }, (0, _i18n.t)('configurator.previewTitle')), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "preview_close"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "previewClose",
        onClick: closePreviewMode
      }, "close")))), /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.wrapperRef,
        className: hasMoreItems ? classes.visualizationWrapperThumbs : classes.visualizationWrapperCanvas
      }, children), hasMoreItems && /*#__PURE__*/_react["default"].createElement(_Thumbnail["default"], {
        previewOpen: true
      }), width !== 'xs' && /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "preview_close"
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        className: classes.CloseEditorRoot,
        alignItems: "center",
        justify: "center"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "text",
        onClick: closePreviewMode,
        classes: {
          root: classes.closePreview
        },
        size: "large"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        classes: {
          root: classes.closePreviewIconRoot
        }
      }, "close"), /*#__PURE__*/_react["default"].createElement("b", null, (0, _i18n.t)('configurator.previewClose'))))));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_reactDom["default"].createPortal(this.renderPreview(), document.getElementById('frame'));
    }
  }]);
  return PreviewPortal;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'Portal'
})((0, _AlignTargetProvider.withAlignTarget)(PreviewPortal)));